<template>
  <div
    ref="rootElement"
    class="white-block"
    :class="{
      'white-block--bordered': bordered,
      'white-block--fixed-appearance': fixedAppearance,
      'white-block--overflow-hidden': overflowHidden,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { ref } from '@/composition/vue/compositionApi'
import TmLogicError from '@/core/error/tmLogicError'

defineProps<{
  bordered?: boolean
  fixedAppearance?: boolean
  overflowHidden?: boolean
}>()

const rootElement = ref<HTMLDivElement | null>(null)

const getRootElement = () => {
  if (!rootElement.value) {
    throw new TmLogicError('rootElement is null')
  }
  return rootElement.value
}

defineExpose({
  getRootElement,
})
</script>

<style lang="scss" scoped>
.white-block {
  border-radius: $border-radius-md;
  box-shadow: var(--white-block-shadow, $white-block-shadow);
  background: $white;
  border: 1px solid $border-color;

  &:not(&--fixed-appearance) {
    @include media-sm-x-max {
      box-shadow: none;
      &:not(.white-block--bordered) {
        border: none;
      }
    }
  }

  &--bordered {
    box-shadow: none;
    border: 1px solid $border-color;
  }

  &--overflow-hidden {
    overflow: hidden;
  }
}
</style>
